import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { ContentStatus, ContentType } from 'enums';
import injectIntl, { intlShape } from 'common/injectIntl';

const Tag = ({
    content,
    intl: { formatMessage },
    messages,
    userIsBlackedOut
}) => {
    const { status, streams, type } = content;

    const classes = classNames('search__results__bug',
        { 'search__results__bug--live': (status === ContentStatus.LIVE) },
        { 'search__results__bug--blackout': userIsBlackedOut });

    let tagContent = null;

    if (userIsBlackedOut) {
        tagContent = formatMessage(messages.blackout).toUpperCase();
    } else if (type === ContentType.VOD) {
        tagContent = streams[0].duration;
    } else {
        tagContent = status.toUpperCase();
    }

    return (
        <span className={classes}>{tagContent}</span>
    );
};

Tag.propTypes = {
    content: PropTypes.object,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired,
    userIsBlackedOut: PropTypes.bool
};

export default injectIntl(Tag);



// WEBPACK FOOTER //
// ./app/common/Tag.js